import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import Error from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { StripeEnvironment } from 'crono-fe-common/types/otherSettings';

export type CheckoutSessionInput = {
  priceId: string | null;
  quantity: number;
  stripeEnvironment?: StripeEnvironment | null;
};

export default function useCheckoutSession() {
  const callCheckout = (input: CheckoutSessionInput) => {
    const request: Request = {
      url: `${ENDPOINTS.subscription.stripeCheckout}`,
      config: {
        method: 'POST',
        data: input,
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<{ url: string }>,
    Error,
    CheckoutSessionInput
  >(callCheckout, {});

  return { data, mutate, ...rest };
}
